import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { PlayLogo } from '@/components/brand/PlayLogo'
import { BackLink } from '@/components/play'
import { SiteFooter } from '@/components/SiteFooter'
import '@/components/onboarding/onboarding.css'

type PublicAuthLayoutProps = {
  eyebrow: string
  title: string
  description: string
  children: ReactNode
  /** Where the back link above the heading goes, and that page's name, such as StreamBridge. */
  backLink?: { to: string; label: string }
  /** Puts the children straight under the description, in one column, for a page whose one action finishes what the
   *  description says, such as the emailed link's Sign in. */
  inline?: boolean
}

export function PublicAuthLayout({ eyebrow, title, description, children, backLink, inline = false }: PublicAuthLayoutProps) {
  return (
    <div className="play-theme play-entry">
      <header className="play-entry-header">
        <Link to="/" aria-label="StreamBridge home"><PlayLogo className="w-40" /></Link>
      </header>
      {/* A row of its own above the grid, which centres its columns, so the link stays top left. */}
      {backLink && (
        <div className="play-entry-back">
          <BackLink to={backLink.to}>{backLink.label}</BackLink>
        </div>
      )}
      <main className={inline ? 'play-entry-grid play-entry-grid--inline' : 'play-entry-grid'}>
        <section className="play-entry-intro">
          <p className="play-eyebrow">{eyebrow}</p>
          <h1>{title}</h1>
          <p className="play-entry-description">{description}</p>
          {inline && <div className="play-entry-inline">{children}</div>}
          <div className="play-entry-words" aria-hidden="true"><span>Great races.</span><span>Real people.</span><span>All together.</span></div>
        </section>
        {!inline && <section className="play-entry-form" aria-label={eyebrow}>{children}</section>}
      </main>
      <SiteFooter />
    </div>
  )
}
